import { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay";
import axios from "../../axios/axios";
import { message } from "antd";
import DataTable from "react-data-table-component";
import { useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import { CSVLink } from "react-csv";
import moment from "moment";
import { DATE_FORMAT } from "../../constants/constants";
import { adminConfig } from "../../utils/adminConfig";

export default function PlanWiseAllMembers() {
  let { source, packageId } = useParams();
  packageId = packageId ? packageId.split("&")[0] : packageId;
  const planName = new URLSearchParams(window.location.search).get("planName");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);
  const [pagination, setPagination] = useState({
    limit: 10,
    page: 1,
    totalPage: 0,
    totalRows: 0,
  });
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [csvData, setCsvData] = useState([]);

  useEffect(() => {
    getAllMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [source, packageId, page, limit, search]);

  const getAllMembers = () => {
    setLoading(true);
    axios
      .get(
        `/reports/plan-wise-members?source=${source}&packageId=${packageId}&page=${page}&limit=${limit}&search=${search}`,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setMembers(res.data.data);
          setPagination(res.data.pagination);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        message.error("Something went wrong");
      });
  };

  const columns = [
    {
      name: "Name",
      selector: ({ userDetails }) => userDetails.name,
      width: "250px",
    },
    {
      name: "Email",
      selector: ({ userDetails }) => userDetails.email,
      width: "300px",
    },
    {
      name: "UserName",
      selector: ({ userDetails }) => userDetails.userName,
      width: "300px",
    },
    {
      name: "Phone",
      selector: ({ userDetails }) => userDetails.phone,
      width: "150px",
    },
    {
      name: "Address",
      selector: ({ userDetails }) => userDetails.address,
      width: "350px",
    },
    {
      name: "Country",
      selector: ({ userDetails }) => userDetails.country,
      width: "100px",
    },
    {
      name: "Status",
      selector: ({ userDetails }) =>
        userDetails.status ? "Active" : "Inactive",
      width: "150px",
    },
    {
      name: "Created At",
      selector: ({ userDetails }) =>
        moment(userDetails.createdAt).format(DATE_FORMAT),
      width: "150px",
    },
  ];

  const handlePerRowsChange = (newPerPage) => {
    setLimit(newPerPage);
    setPage(1);
  };

  const changePage = (newPage) => {
    setPage(newPage);
  };

  const exportCSV = () => {
    setLoading(true);
    axios
      .get(
        `/reports/csv-plan-wise-members?source=${source}&packageId=${packageId}&search=${search}`,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const csvData = res.data.data.map(({ userDetails }) => ({
            Name: userDetails.name,
            Email: userDetails.email,
            UserName: userDetails.userName,
            Phone: userDetails.phone,
            Address: userDetails.address,
            Country: userDetails.country,
            Status: userDetails.status ? "Active" : "Inactive",
            CreatedAt: moment(userDetails.createdAt).format("MM-DD-YYYY"),
          }));
          setCsvData(csvData);
          setTimeout(() => {
            document.getElementById("csv-download-link").click();
            setLoading(false);
          }, 2000);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const csvHeaders = [
    { label: "Name", key: "Name" },
    { label: "Email", key: "Email" },
    { label: "UserName", key: "UserName" },
    { label: "Phone", key: "Phone" },
    { label: "Address", key: "Address" },
    { label: "Country", key: "Country" },
    { label: "Status", key: "Status" },
    { label: "CreatedAt", key: "CreatedAt" },
  ];

  return (
    <LoadingOverlay active={loading} spinner text="Loading ...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <div className="ar_count_card d-flex">
                  <h3>{planName} Package</h3>
                  <div className="ar_count">{pagination.totalRows}</div>
                </div>
                <div className="filter_section">
                  <div className="input-group filter_fields">
                    <div className="search_field">
                      <input
                        placeholder="Type name or email or phone"
                        type="text"
                        id="form1"
                        className="form-control"
                        onChange={(e) => {
                          setQuery(e.target.value);
                        }}
                        value={query}
                      />
                    </div>
                    <Button
                      className="search_button"
                      variant="primary"
                      onClick={() => {
                        setSearch(query);
                        setPage(1);
                      }}
                    >
                      Search
                    </Button>
                    <Button
                      className="search_button"
                      variant="secondary"
                      onClick={() => {
                        setSearch("");
                        setQuery("");
                        setPage(1);
                      }}
                    >
                      Clear Filter
                    </Button>
                  </div>
                  <div className="filter_btns">
                    <Button
                      className="btn btn-primary search_button"
                      onClick={exportCSV}
                    >
                      Export CSV
                    </Button>
                    <CSVLink
                      data={csvData}
                      headers={csvHeaders}
                      filename={`${source}_active_plan_wise_members.csv`}
                      className="hidden"
                      id="csv-download-link"
                      target="_blank"
                    />
                  </div>
                </div>

                <DataTable
                  columns={columns}
                  data={members}
                  pagination
                  striped
                  responsive
                  customStyles={customStyles}
                  subHeaderAlign="right"
                  subHeaderWrap
                  paginationDefaultPage={page}
                  paginationServer
                  paginationTotalRows={pagination.totalRows}
                  paginationPerPage={limit}
                  paginationRowsPerPageOptions={[10, 15, 20, 40]}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={changePage}
                  className={members.length === 1 ? "search_state" : ""}
                  progressComponent={<CustomLoader />}
                  noDataComponent={<EmptyDataLoader />}
                  fixedHeaderScrollHeight="500px"
                  fixedHeader
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#004aad",
    },
  },
  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};

const CustomLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>Loading...</div>
  </div>
);
const EmptyDataLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>No data found...</div>
  </div>
);
